import React, { FC } from 'react';
import { useGigPageContext } from '@fiverr-private/gig_page_context';
import { AISummaryMode } from '../../interface/sellerInfo';
import { AISummary } from './AISummary';

interface AISummaryWrapperProps {
  mode: AISummaryMode;
  summary?: string[];
}

export const AISummaryWrapper: FC<AISummaryWrapperProps> = ({ mode, summary }) => {
  const {
    biankaEvents: { reportAISummaryToggle, reportAISummaryImpression },
  } = useGigPageContext();

  if (mode === AISummaryMode.DISPLAY && summary) {
    return <AISummary summary={summary} onToggle={reportAISummaryToggle} onImpression={reportAISummaryImpression} />;
  }

  return null;
};
